export default "__VITE_ASSET__BMyTyBaz__"